import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import * as CryptoJS from "crypto-js";
import { environment } from "environments/environment";
import { Observable } from "rxjs/Observable";

import { ClienteModel } from "./../../model/cliente/cliente.model";
import { ClienteVinculo } from "./../../model/cliente/clientevinculo.model";
import { ResponsePageable } from "./../../model/cliente/pageable/responsePageable.model";
import { RoleModel } from "./../../model/usuario/role.model";
import { UsuarioModelAlfresco } from "./../../model/usuario/usuario-alfresco.model";
import { UsuarioModel } from "./../../model/usuario/usuario.model";

export interface CodeSendedResponse {
  isSended: boolean;
  message: string;
  mobile: string;
  timeCanCallAgain: number;
  numberOfAttempts: number;
}

export interface ObjectoVerificacao {
  isValid: boolean;
  message: string;
}

export interface VerifyUserResponse {
  userHasToChangePassword: boolean;
  userHasTwoFactorAuth: boolean;
}

@Injectable()
export class PermissoesService {

  apiURL = environment.API;
  apiURLPublic = environment.APIpublic;

  userAdmin = false;

  httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };

  constructor(private httpCliente: HttpClient) {}

  userAutenticado() {
    return this.userAdmin;
  }
  getUsuarios(): any {
    let result: any;
    //result = this.httpCliente.get<UsuarioModelAlfresco>(this.apiURL + '/alfresco-users', this.httpOptions)

    return this.httpCliente.get<UsuarioModelAlfresco>(
      this.apiURL + "/alfresco-users",
      this.httpOptions
    );
  }

  getUserNovo(
    userId: String,
    ticket: any,
    authorization: any
  ): Observable<UsuarioModel> {
    const headers = new HttpHeaders()
      .set("ticket", ticket)
      .set("Authorization", authorization);

    return this.httpCliente.get<UsuarioModel>(
      this.apiURLPublic + `/get-user-userid?userId=${userId}`,
      { headers }
    );
  }

  setLastLoginUser(userName: any): Observable<any> {
    return this.httpCliente.post<any>(
      this.apiURLPublic + `/set-last-login?userName=${userName}`,
      this.httpOptions
    );
  }

  changeUserPassword(
    userId: String,
    password: String,
    ticket: string[],
    isLoggedAlfresco
  ): Observable<UsuarioModel> {
    const headers = new HttpHeaders()
      .set("ticket", ticket)
      .set("Content-Type", "application/json");

    const data = {
      userId,
      password,
      isLoggedAlfresco,
    };
    const dataJson = JSON.stringify(data);

    return this.httpCliente.post<UsuarioModel>(
      this.apiURLPublic + "/change-user-pass",
      dataJson,
      { headers }
    );
  }

  getEmpresasVinculadas(idUser: String): Observable<Array<ClienteVinculo>> {
    return this.httpCliente.get<Array<ClienteVinculo>>(
      this.apiURL + `/listar-vinculo-cliente/${idUser}/`,
      this.httpOptions
    );
  }

  postVinculoEmpresa(form: FormGroup): Observable<String> {
    return this.httpCliente.post<String>(
      this.apiURL + `/vincular-empresas-cliente`,
      form,
      this.httpOptions
    );
  }

  getRolesUsuario(idUser: number): Observable<Array<RoleModel>> {
    return this.httpCliente.get<Array<RoleModel>>(
      this.apiURL + `/permission/${idUser}/roles`,
      this.httpOptions
    );
  }

  getRoles(): Observable<Array<RoleModel>> {
    return this.httpCliente.get<Array<RoleModel>>(
      this.apiURL + "/permission/listar-roles",
      this.httpOptions
    );
  }

  getUsuariosRole(idRole: number): Observable<Array<UsuarioModel>> {
    return this.httpCliente.get<Array<UsuarioModel>>(
      this.apiURL + `/permission/${idRole}/usuarios`,
      this.httpOptions
    );
  }

  removeUserRole(idUser: number, role: RoleModel) {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpCliente.post(
      this.apiURL + `/permission/remover-role-usuario/${idUser}`,
      role,
      { responseType: "text", headers }
    );
  }

  postUserRole(idUser: number, role: RoleModel): Observable<RoleModel> {
    return this.httpCliente.post<RoleModel>(
      this.apiURL + `/permission/add-role-usuario/${idUser}`,
      role,
      this.httpOptions
    );
  }

  searchUsuario(nome: String): Observable<Array<UsuarioModel>> {
    return this.httpCliente.get<Array<UsuarioModel>>(
      this.apiURL + `/permission/busca-usuarios?nome=${nome}`,
      this.httpOptions
    );
  }

  getUserLogado(): any {
    return this.httpCliente.get<any>(
      this.apiURL + "/permission/usuario-logado",
      this.httpOptions
    );
  }

  getPermissionEmpresa(idCliente: number): any {
    return this.httpCliente.get<any>(
      this.apiURL + `/permission/get-permission-por-cliente/${idCliente}`,
      this.httpOptions
    );
  }

  getPermissionUsuario(): any {
    return this.httpCliente.get<any>(
      this.apiURL + `/permission/get-permission-por-usuario`,
      this.httpOptions
    );
  }

  isAdminUser(): any {
    return this.httpCliente.get<any>(
      this.apiURL + `/permission/is-admin`,
      this.httpOptions
    );
  }

  getUserUnico(id: number): Observable<UsuarioModel> {
    return this.httpCliente.get<UsuarioModel>(
      this.apiURL + `/permission/usuario-unico/${id}`,
      this.httpOptions
    );
  }

  getSearchRole(name: String): Observable<Array<RoleModel>> {
    return this.httpCliente.get<Array<RoleModel>>(
      this.apiURL + `/permission/busca-roles?name=${name}`,
      this.httpOptions
    );
  }

  getSearchCliente(nome: String): Observable<Array<ClienteModel>> {
    return this.httpCliente.get<Array<ClienteModel>>(
      this.apiURL + `/permission/buscar-clientes?nome=${nome}`,
      this.httpOptions
    );
  }

  getUsuariosRM(page: number, size: number): Observable<ResponsePageable> {
    return this.httpCliente.get<ResponsePageable>(
      this.apiURLPublic + `/usuarios/listar?page=${page}&size=${size}`,
      this.httpOptions
    );
  }

  getUsuarioRM(id: number): Observable<UsuarioModel> {
    return this.httpCliente.get<UsuarioModel>(
      this.apiURL + `/permission/detalhes-usuario-permissao/${id}`,
      this.httpOptions
    );
  }

  deleteRolePermissions(id: number) {
    return this.httpCliente.delete<any>(
      this.apiURL + `/group-remove/${id}`,
      this.httpOptions
    );
  }

  deleteUserPermissionEmpresa(upe) {
    return this.httpCliente.post<any>(
      this.apiURL + `/permission/remove-permissions-cliente`,
      upe,
      this.httpOptions
    );
  }

  postRoleEmpresa(role): Observable<any> {
    return this.httpCliente.post<any>(
      this.apiURL + `/group-permission/add`,
      role,
      this.httpOptions
    );
  }

  getPermissionNotIn(usuarioId, empresaId): Observable<any> {
    return this.httpCliente.get<any>(
      this.apiURL + `/permission/get-not-in/${usuarioId}/${empresaId}`,
      this.httpOptions
    );
  }

  getPermissionNotInUser(usuarioId): Observable<any> {
    return this.httpCliente.get<any>(
      this.apiURL + `/permission/get-not-in-user/${usuarioId}`,
      this.httpOptions
    );
  }

  getPermissionIn(usuarioId, empresaId): Observable<any> {
    return this.httpCliente.get<any>(
      this.apiURL + `/permission/get-in/${usuarioId}/${empresaId}`,
      this.httpOptions
    );
  }

  getPermissionInUser(usuarioId): Observable<any> {
    return this.httpCliente.get<any>(
      this.apiURL + `/permission/get-in-user/${usuarioId}`,
      this.httpOptions
    );
  }
  /**
   * Get the globals permissions which user is attached.
   */
  getPermissionsInUserLogged(): Observable<any> {
    return this.httpCliente.get<any>(
      this.apiURL + "/permission/get-in-user-logged",
      this.httpOptions
    );
  }

  postPerssionsCliente(obj) {
    return this.httpCliente.post<any>(
      this.apiURL + `/permission/add-permissions-cliente`,
      obj,
      this.httpOptions
    );
  }

  postPerssionsUser(obj) {
    return this.httpCliente.post<any>(
      this.apiURL + `/permission/add-permissions-por-user`,
      obj,
      this.httpOptions
    );
  }

  setItemAuthority(key, value) {
    const store: any = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      sessionStorage.getItem("ticket-ECM")
    );
    return sessionStorage.setItem(key, store);
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem("ticket-ECM")
        );
        const arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return arrayString;
      } catch (e) {
        console.log(e);
        sessionStorage.clear();
      }
    }
    return null;
  }

  verificarAcessoApp(userId: String): Observable<Boolean> {
    console.log(this.httpOptions);
    return this.httpCliente.post<Boolean>(
      this.apiURLPublic + `/verificar-acesso-app?userId=${userId}`,
      environment.URL_RM,
      this.httpOptions
    );
  }

  enviarCodigoSMSAuthentication(
    userId: string
  ): Observable<CodeSendedResponse> {
    return this.httpCliente.post<CodeSendedResponse>(
      `${environment.API}/2fa/enviar-codigo-autenticacao?username=${userId}`,
      null
    );
  }

  verificarCodigoAuth(
    username: string,
    codigo: string
  ): Observable<ObjectoVerificacao> {
    return this.httpCliente.post<ObjectoVerificacao>(
      `${environment.API}/2fa/verificar-codigo-autenticacao?username=${username}&codigo=${codigo}`,
      null
    );
  }

  verifyUser(user: any): Observable<VerifyUserResponse> {
    return this.httpCliente.get<VerifyUserResponse>(
      this.apiURLPublic + `/verify-user?userId=${user}`
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/usuario/permissoes.service.ts